import "@amir04lm26/react-modern-calendar-date-picker/lib/DatePicker.css";
import ModernDatePicker, { DayValue, Day } from "@amir04lm26/react-modern-calendar-date-picker";
import styles from './style.module.scss';
import { CalendarIcon } from "../../assets/icons";

interface Props {
    label?: string;
    minimumDate?: Day;
    placeholder: string;
    errorMessage?: string;
    selectedDate: DayValue;
    inputClassName?: string;
    wrapperClassName?: string;
    showErrorMessage?: boolean;
    containerClassName?: string;
    setSelectedDate: (val: DayValue) => void;
};

function DatePicker(props: Props) {
    const {
        label,
        placeholder,
        errorMessage,
        selectedDate,
        minimumDate,
        inputClassName,
        showErrorMessage,
        wrapperClassName,
        setSelectedDate,
        containerClassName,
    } = props;

    const formatDateInput = () => {
        if (!selectedDate) return '';
        return `${selectedDate.month < 10 ?
            `0${selectedDate.month}` : selectedDate.month}-${selectedDate.day < 10 ?
                `0${selectedDate.day}` : selectedDate.day}-${selectedDate.year}`;
    };

    return (
        <div className={`${styles.container} ${containerClassName || ''}`}>
            {label && <span className={styles.label}>{label}</span>}
            <div
                className={styles.custom_select}
                data-has-error={Boolean(errorMessage)}
            >
                <ModernDatePicker
                    locale="en"
                    value={selectedDate}
                    shouldHighlightWeekends
                    minimumDate={minimumDate}
                    inputPlaceholder={placeholder}
                    inputClassName={inputClassName}
                    formatInputText={formatDateInput}
                    wrapperClassName={wrapperClassName}
                    onChange={(val) => setSelectedDate(val)}
                    calendarSelectedDayClassName={styles.selectedDay}
                />
                <CalendarIcon className={styles.custom_select_icon} />
            </div>
            {showErrorMessage && errorMessage && (<span className={styles.error}>{errorMessage}</span>)}
        </div>
    );
};

export default DatePicker;
